import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { CSVLink } from 'react-csv';


class DownloadUtils extends React.Component {
  static getDownloadDataForChart(data, xAxisValueAttr, valueAttr) {
    let allAttributes = [xAxisValueAttr].concat(valueAttr);
    return DownloadUtils.getDownloadData(data, allAttributes);
  }

  static getDownloadData(data, attributes) {
    let downloadData = [];

    for (let i = 0; i < data.length; i++) {
      let record = data[i];
      let newRecord = {};
      for (let j = 0; j < attributes.length; j++) {
        let attribute = attributes[j];
        newRecord[attribute] = record[attribute];
      }

      downloadData.push(newRecord);
    }

    return downloadData;
  }

  static getDownloadLink(downloadData, filename) {
    return (
      <CSVLink data={downloadData()} filename={filename + ".csv"}>
        <u>Download data used in this screen (CSV format)</u>
      </CSVLink>
    )
  }
  

  static getDownloadIconWithData(downloadData, filename) {
    return (
      <CSVLink data={downloadData} filename={filename + ".csv"}>
        <i className="mediaCustom fas fa-file-download fa-lg" />
      </CSVLink>
    )
  }

  static getDownloadLinkWithLabel(downloadData, filename, label) {
    return (
      <CSVLink data={downloadData()} filename={filename + ".csv"}>
        <u>{label}</u>
      </CSVLink>
    )
  }

}

export default DownloadUtils;
